/**
 * View Design URL route parsing.
 * Supports (query format for AWS-friendly URLs, no path slashes):
 *   - ?view-design?<designId> (primary)
 *   - ?view-design=<designId>
 *   - ?configurator?<designId> (legacy)
 * Path-based formats still supported for local/dev:
 *   - /view-design/:designId
 *   - /configurator/:designId
 */

/**
 * Returns the design ID from the current URL (search or path).
 * @returns {string|null} The design ID or null if not present.
 */
export function getViewDesignIdFromPath() {
  if (typeof window === "undefined") return null;
  const search = window.location.search || "";
  const path = window.location.pathname || "";
  // Query format: ?view-design?uuid or ?view-design=uuid (and legacy configurator)
  const fromSearch = search.match(/[?&](?:view-design|configurator)[?=]([^&]+)/);
  if (fromSearch) return fromSearch[1];
  // Path format (local/dev): /view-design/:id or /configurator/:id
  const fromPath = path.match(/^\/(?:view-design|configurator)\/([^/]+)$/);
  return fromPath ? fromPath[1] : null;
}

/**
 * Returns the value of the `source` query parameter from the current URL.
 * Used to identify the origin of a view-design link (e.g. "admin").
 * @returns {string|null} The source value or null if not present.
 */
export function getViewDesignSourceFromPath() {
  if (typeof window === "undefined") return null;
  const search = window.location.search || "";
  const match = search.match(/[?&]source=([^&]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}
